export const cost = {
  menu: 'Cost',
  title: 'Cost',
  subtitle: (org: string) => `What ${org}'s use of Queri costs this month, in SEK.`,
  noAccess: "Only your organization's admins can see its costs.",
  loadFailed: 'Could not load the cost',
  month: 'Month',
  spent: 'Spent this month',
  of: (ceiling: string) => `of ${ceiling} monthly ceiling`,
  noCeiling: 'No monthly ceiling agreed',
  percent: (p: string) => `${p}% of the ceiling`,
  projected: (amount: string) => `At this pace about ${amount} by the end of the month`,
  overCeilingSoon: 'At this pace the month will end above the ceiling.',
  reached: 'The ceiling is reached. Queri keeps working; we will contact you before anything changes.',
  alertNote: 'Admins get an email at 80% and 100% of the ceiling.',
  daily: 'Per day',
  byActivity: 'By activity',
  byPerson: 'By person',
  activity: 'Activity',
  person: 'Person',
  amount: 'Cost',
  share: 'Share',
  nothingYet: 'No usage this month yet.',
  previous: 'Earlier months',
  rateNote: (rate: string) => `Converted from the AI providers' USD prices at ${rate} SEK per USD.`,
  unknownPerson: 'Background jobs',
  categories: {
    review: 'Contract review',
    drafting: 'Drafting',
    questions: 'Questions and chat',
    wordAddIn: 'Word add-in',
    playbooks: 'Playbooks',
    email: 'Email agent',
    meetings: 'Meetings',
    other: 'Search and other',
  } as Record<string, string>,
};

export type CostDict = typeof cost;
